/**
 * Kollektion (editorial): horizontales Wischen + Tippen öffnet die Produktseite.
 */
(function () {
  const ROOT = '.collection--rf-editorial';
  const SWIPE = '[data-rf-card-swipe]';
  const TRACK = '.rf-card__media-swipe-track';
  const TAP_MOVE_THRESHOLD = 12;

  function snapAfterScroll(track) {
    const slide = track.querySelector('.rf-card__media-swipe-slide');
    if (!slide) return;
    const slideWidth = slide.offsetWidth;
    if (!slideWidth) return;
    const index = Math.round(track.scrollLeft / slideWidth);
    track.scrollTo({ left: index * slideWidth, behavior: 'smooth' });
  }

  function bindTapToProduct(swipe) {
    if (!swipe || swipe.dataset.rfTapBound === 'true') return;
    swipe.dataset.rfTapBound = 'true';

    const productUrl = swipe.dataset.productUrl;
    const track = swipe.querySelector(TRACK);
    if (!productUrl || !track) return;

    let startX = 0;
    let startY = 0;
    let startScrollLeft = 0;
    let didSwipe = false;
    let suppressClick = false;

    const markSwipe = () => {
      didSwipe = true;
    };

    swipe.addEventListener(
      'touchstart',
      (event) => {
        if (event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        startScrollLeft = track.scrollLeft;
        didSwipe = false;
      },
      { passive: true }
    );

    swipe.addEventListener(
      'touchmove',
      (event) => {
        if (event.touches.length !== 1) return;
        const dx = Math.abs(event.touches[0].clientX - startX);
        const dy = Math.abs(event.touches[0].clientY - startY);
        if (dx > TAP_MOVE_THRESHOLD || dy > TAP_MOVE_THRESHOLD) {
          markSwipe();
        }
      },
      { passive: true }
    );

    track.addEventListener('scroll', markSwipe, { passive: true });

    swipe.addEventListener(
      'touchend',
      (event) => {
        if (track.classList.contains('rf-card__media-swipe-track--dragging')) {
          markSwipe();
        }
        if (Math.abs(track.scrollLeft - startScrollLeft) > 4) {
          markSwipe();
        }
        if (didSwipe) return;
        if (event.changedTouches.length !== 1) return;

        const dx = Math.abs(event.changedTouches[0].clientX - startX);
        const dy = Math.abs(event.changedTouches[0].clientY - startY);
        if (dx > TAP_MOVE_THRESHOLD || dy > TAP_MOVE_THRESHOLD) return;

        suppressClick = true;
        window.setTimeout(() => {
          suppressClick = false;
        }, 400);
        window.location.assign(productUrl);
      },
      { passive: true }
    );

    swipe.addEventListener('click', (event) => {
      if (suppressClick || didSwipe) {
        event.preventDefault();
        return;
      }
      if (event.target.closest('a, button')) return;
      window.location.assign(productUrl);
    });
  }

  function bindDragScroll(track) {
    if (!track || track.dataset.rfSwipeBound === 'true') return;
    track.dataset.rfSwipeBound = 'true';

    let active = false;
    let axis = null;
    let startX = 0;
    let startY = 0;
    let startScroll = 0;

    const endDrag = () => {
      if (!active) return;
      active = false;
      axis = null;
      track.classList.remove('rf-card__media-swipe-track--dragging');
      snapAfterScroll(track);
    };

    track.addEventListener(
      'touchstart',
      (event) => {
        if (event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        startScroll = track.scrollLeft;
        active = true;
        axis = null;
      },
      { passive: true }
    );

    track.addEventListener(
      'touchmove',
      (event) => {
        if (!active || event.touches.length !== 1) return;

        const dx = event.touches[0].clientX - startX;
        const dy = event.touches[0].clientY - startY;

        if (!axis) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }

        if (axis !== 'x') {
          active = false;
          return;
        }

        event.preventDefault();
        track.classList.add('rf-card__media-swipe-track--dragging');
        track.scrollLeft = startScroll - dx;
      },
      { passive: false }
    );

    track.addEventListener('touchend', endDrag, { passive: true });
    track.addEventListener('touchcancel', endDrag, { passive: true });
  }

  function init(scope) {
    const container =
      scope && typeof scope.matches === 'function' && scope.matches(ROOT)
        ? scope
        : scope?.querySelector?.(ROOT) || document.querySelector(ROOT);

    if (!container) return;

    container.querySelectorAll(SWIPE).forEach((swipe) => {
      bindDragScroll(swipe.querySelector(TRACK));
      bindTapToProduct(swipe);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
